import React from 'react'
import { Container, Row, Col } from "react-bootstrap";
import angular from "../Assets/Skills/angular.png";
import react from "../Assets/Skills/react.png";
import typescript from "../Assets/Skills/typescript.png";
import node from "../Assets/Skills/nodejs.png";
import aws from "../Assets/Skills/aws.png";
import figma from "../Assets/Skills/figma.png";
import wordpress from "../Assets/Skills/wordpress.png";
import laravel from "../Assets/Skills/laravel.png";
import express from "../Assets/Skills/express.png";
import nginx from "../Assets/Skills/nginx.png";
import html from "../Assets/Skills/html5.png";
import css from "../Assets/Skills/css3.png";
import firebase from "../Assets/Skills/firebase.png";
import bootstrap from "../Assets/Skills/bootstrap.png";
import github from "../Assets/Skills/github.png";
import confluence from "../Assets/Skills/confluence.png";
import canva from "../Assets/Skills/canva.png";
import behance from "../Assets/Skills/behance.png";
import javascript from "../Assets/Skills/javascript.png";
import jquery from "../Assets/Skills/jquery.png";
import mongoDB from "../Assets/Skills/mongodb.png";
import jira from "../Assets/Skills/jira.png";
import mySQL from "../Assets/Skills/mysql.png";
import Next from "../Assets/Skills/nextjs.png";
import notion from "../Assets/Skills/notion.png";
import npm from "../Assets/Skills/npm.png";
import php from "../Assets/Skills/php.png";
import postgreSQL from "../Assets/Skills/postgresql.png";
import postman from "../Assets/Skills/postman.png";
import tailwind from "../Assets/Skills/tailwindcss.png";
import vscode from "../Assets/Skills/vscode.png";
import woocommerce from "../Assets/Skills/woocommerce.png";
import Particle from "./Particle";
import ai from '../Assets/Skills/AI.png'




function Technology() {
    // Add more tools as needed
const toolsData = [
   { name: "Next.js", logo: Next, color: "bg-white" },
    { name: "Angular.js", logo: angular, color: "bg-white" },
    { name: "React.js", logo: react, color: "bg-white" },
    { name: "AI & Automation", logo: ai, color: "bg-white" },
    { name: "javascript", logo: javascript, color: "bg-white" },
    { name: "typescript", logo: typescript, color: "bg-white" },
    { name: "Figma", logo: figma, color: "bg-white" },
    { name: "html", logo: html, color: "bg-white" },
    { name: "css", logo: css, color: "bg-white" },
    { name: "bootstrap", logo: bootstrap, color: "bg-white" },
    { name: "tailwind", logo: tailwind, color: "bg-white" },
    { name: "WordPress", logo: wordpress, color: "bg-white" },
    { name: "github", logo: github, color: "bg-white" },
    { name: "postman", logo: postman, color: "bg-white" },
    { name: "vscode", logo: vscode, color: "bg-white" },
    { name: "woocommerce", logo: woocommerce, color: "bg-white" },
    { name: "jira", logo: jira, color: "bg-white" },
    { name: "confluence", logo: confluence, color: "bg-white" },
    { name: "notion", logo: notion, color: "bg-white" },
    { name: "Node.js", logo: node, color: "bg-white" },
    { name: "AWS", logo: aws, color: "bg-white" },
    { name: "express", logo: express, color: "bg-white" },
    { name: "nginx", logo: nginx, color: "bg-white" },
    { name: "jquery", logo: jquery, color: "bg-white" },
    { name: "firebase", logo: firebase, color: "bg-white" },
    { name: "mongoDB", logo: mongoDB, color: "bg-white" },
    { name: "postgreSQL", logo: postgreSQL, color: "bg-white" },
    { name: "mySQL", logo: mySQL, color: "bg-white" },
    { name: "canva", logo: canva, color: "bg-white" },
    { name: "behance", logo: behance, color: "bg-white" },
    { name: "npm", logo: npm, color: "bg-white" },
    { name: "php", logo: php, color: "bg-white" },
    { name: "Laravel", logo: laravel, color: "bg-white" },
   
 



  ];


  return (
    <Container fluid className="tools-section  mt-5 pt-5 " id="tools">
     <Particle />
      <Container>
        <h2 style={{ fontSize: "2.6em" , marginBottom: "2rem"}} className="text-center">
          <span className="text-white"> Tools & </span>
          <span className="purple"> Technologies </span>
        </h2>
        
        <Row className="justify-content-center">
          {toolsData.map((tool, index) => (
            <Col
              key={index}
              xs={6}
              sm={4}
              md={3}
              lg={2}
              className="mb-4 d-flex align-items-stretch"
            >
              <div
                className={`w-100 text-center p-3 rounded shadow-xxl ${tool.color}`}
              >
                <img
                  src={tool.logo}
                  alt={tool.name}
                  className="tool-logo mb-2"
                />
                <h5 className="text-white skill-badge">{tool.name}</h5>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Technology
